/**
 * @generated SignedSource<<04561766285988c62da527f8cee11e5d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CourseVisibility = "MEMBER_ONLY" | "PRIVATE" | "PUBLIC" | "SECRET" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type coursePreview_paywall$data = {
  readonly primaryProduct: {
    readonly checkoutUrl: string | null | undefined;
  } | null | undefined;
  readonly visibility: CourseVisibility;
  readonly " $fragmentType": "coursePreview_paywall";
};
export type coursePreview_paywall$key = {
  readonly " $data"?: coursePreview_paywall$data;
  readonly " $fragmentSpreads": FragmentRefs<"coursePreview_paywall">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "coursePreview_paywall",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visibility",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PaymentIntegrationProduct",
      "kind": "LinkedField",
      "name": "primaryProduct",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "checkoutUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Course",
  "abstractKey": null
};

(node as any).hash = "d408185f760f222b190b51babdd30566";

export default node;
